<template>
    <div @click="click($event)" :class="['auto-complete',{'focus': focus}]">
        <input class="present-input ellipsis"
               type="text"
               :placeholder="placeholder"
               :disabled="disabled"
               @focus="focusInput"
               v-model="inputValue"/>
        <div v-show="focus" class="bg-effect" @click="hide()"></div>
        <div v-show="focus" ref="list" class="input-list">
            <div class="focus-input-wrap">
                <div v-for="(item, key) in selectedItems" :key="key">
                  <div class="selected-items">
                    <span>{{item.text}}</span>
                    <icon name="close"
                          width="9px"
                          height="9px"
                          fill="var(--white-color)"
                          @click.native="removeItem(item, key)"
                          class="close-icon" />
                  </div>
                </div>
                <input class="focus-input"
                       type="text"
                       ref="autoComplateInput"
                       :placeholder="placeholder"
                       @input="searchItem"
                       v-model="focusInputValue"/>
            </div>
            <div class="shadow-inset"></div>
            <template v-if="isEmpty">
                <div class="list-item">
                    <p class="list-item-text">{{ localizeList.noResults }}</p>
                </div>
            </template>
            <template v-else>
                <div v-for="(item, key) in sortedSearchItems"
                     :key="key"
                     ref="listItem"
                     :class="['list-item', { hover: activeItemPosition === key}]">
                    <checkbox v-model="item.isChecked"
                              @change="checked(key, item)"
                              :label="item.text"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

    export default {
        name: "quotes-auto-complete-combo",
        data() {
            return {
                inputValue: "",
                focusInputValue: "",
                focus: false,
                searchItems: [],
                selectedItem: {},
                selectedItems: [],
                activeItemPosition: 0,
                hotelsKeys: [],
            }
        },
        props: {
            placeholder: {
                type: String,
                default: "text"
            },
            value: {
                type: Object,
                default: () => {}
            },
            items: {
                type: Array,
                default: () => []
            },
            allItems: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: false
            },
            focusFromParent: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            selectedItemsOnReboot: {
                type: Array,
                default: () => []
            }

        },
        mounted() {
            if (this.items) {
                this.searchItems = this.items
            }
        },
        computed: {
            sortedSearchItems() {
              let sortedItems = [...this.searchItems]
                .sort((a, b) => {
                  // Проверяем, имеет ли какой-либо из элементов идентификатор -1, и сортируем соответствующим образом
                  if (b.id === -1) return 1;

                  // Если ни один элемент не имеет идентификатора -1, сортируем по тексту
                  const first = a.text.toLowerCase();
                  const second = b.text.toLowerCase();
                  return first > second ? 1 : first < second ? -1 : 0;
                })
              return sortedItems;
            },
            categoryText() {
                return `${this.localizeList.category} ${this.selectedItem.categoryName} (${this.selectedItem.hotelName})`;
            },
            isEmpty() {
                return this.focusInputValue && !this.loading && !this.sortedSearchItems.length
            },
        },
        methods: {
            focusInput() {
                this.focus = true;
                this.$emit("search", this.focusInputValue);
            },
            keyDown(e) {
                if (e.keyCode === 9) {
                    this.hide()
                }
                if (e.keyCode === 38) {
                    this.activeItemPosition =
                        this.activeItemPosition + -1 > 0 ? this.activeItemPosition - 1 : 0;

                    this.scrollToActiveItem();
                }
                if (e.keyCode === 40) {
                    const max = this.sortedSearchItems.length - 1;
                    this.activeItemPosition =
                        this.activeItemPosition < max ? this.activeItemPosition + 1 : max;

                    this.scrollToActiveItem();
                }
                if (e.keyCode === 13) {
                    this.checked(this.activeItemPosition);
                }
            },
            async scrollToActiveItem() {
                await this.$nextTick();

                if (!this.sortedSearchItems.length) return;

                const listHeigth = this.$refs.list.clientHeight;
                const listTop = this.$refs.list.scrollTop;
                const activeItem = Array.from(this.$refs.listItem).find(x => x.classList.value.includes("hover"));
                const activeItemHeight = activeItem.clientHeight;
                const activeItemTop = activeItem.offsetTop;

                const listBottom = listTop + listHeigth;
                const itemPosition = activeItemTop + activeItemHeight;

                if (itemPosition > listBottom) {
                    this.$refs.list.scrollTo(0, itemPosition - listHeigth)
                }

                if (activeItemTop < listBottom - listHeigth) {
                    this.$refs.list.scrollTo(0, activeItemTop)
                }
            },
            checked(key, item) {
              this.activeItemPosition = key;

              if (item.id === -1) {
                if (!item.isChecked) {
                  this.selectedItems = this.items.map(item => {
                     const isChecked = true;
                     return { ...item, isChecked };
                  });
                  this.searchItems = this.selectedItems;
                  this.hotelsKeys = this.items.map(item => item.hotelKey);
                  this.selectedItem = this.items[0];
                } else {
                  this.selectedItems = [];
                  this.hotelsKeys = [];
                  this.selectedItem = {};
                  this.searchItems = this.searchItems.map(item => {
                     const isChecked = false;
                     return { ...item, isChecked };
                  });
                }
              } else {
                if (!item.isChecked) {
                  this.selectedItem = item;
                  this.selectedItems.push(item);
                  this.hotelsKeys.push(item.hotelKey)
                } else {
                  this.selectedItems = this.selectedItems.filter(x => x.id !== item.id)
                  this.selectedItem = this.selectedItems.at(-1)
                  this.hotelsKeys = this.hotelsKeys.filter(x => x !== item.hotelKey)
                  this.searchItems = this.searchItems.map(x => {
                      if (x.id === item.id) {
                          x.isChecked = false
                      }
                      return x
                  });

                  if (this.selectedItems.length === 1 && this.selectedItems[0].id === -1) {
                    this.selectedItems = [];
                    this.hotelsKeys = [];
                    this.selectedItem = {};
                    this.searchItems = this.searchItems.map(item => {
                       const isChecked = false;
                       return { ...item, isChecked };
                    });
                  }

                  if (this.selectedItems.length !== this.items.length) {
                    this.selectedItems = this.selectedItems.filter(x => x.id !== -1);
                    this.searchItems = this.searchItems.map(x => {
                        if (x.id === -1) {
                            x.isChecked = false
                        }
                        return x
                    });
                  }
                }
              }

              this.$emit("change", this.selectedItem);
              this.$emit("input", this.selectedItem);
              this.$emit('changeHotelsKeys', this.hotelsKeys);
            },
            click(e) {
                this.$emit("click", e);
            },
            setText() {
                const arrWthoutSelectAll = this.selectedItems.filter(item => item.id !== -1);
                this.inputValue = arrWthoutSelectAll.map(item => item.text).join(", ");
                this.$emit("inputValue", this.inputValue);
            },
            searchItem() {
                this.$emit("search", this.focusInputValue)
            },
            removeItem(item) {
              if (item.id === -1) {
                this.selectedItems = [];
                this.hotelsKeys = [];
                this.selectedItem = {};
                this.$emit('changeHotelsKeys', this.hotelsKeys)
                this.searchItems = this.searchItems.map(item => {
                   const isChecked = false;
                   return { ...item, isChecked };
                })
              } else {
                this.selectedItem = {};
                this.selectedItems = this.selectedItems.filter(x => x.id !== item.id)
                this.hotelsKeys = this.hotelsKeys.filter(x => x !== item.hotelKey)
                this.$emit('changeHotelsKeys', this.hotelsKeys)
                this.searchItems = this.searchItems.map(x => {
                    if (x.id === item.id) {
                        x.isChecked = false
                    }
                    return x
                })
              }
            },
            hide() {
                this.focus = false;
                this.$emit("blur")
            },
            setValue() {
                this.selectedItem = {...this.value};
            }
        },
        updated() {
            if (this.focus) {
                this.click(true)
            }
        },
        watch: {
            focusFromParent(val) {
                if (val) {
                    this.focus = true
                }
            },
            items: {
                deep: true,
                handler(val) {
                    const selectedItemsKeys = this.selectedItems.map(item => item.hotelKey);

                    const checkSelectedItems = val.map(item => {
                       const isChecked = selectedItemsKeys.includes(item.hotelKey);
                       return {...item, isChecked}
                    });

                    let set = new Set(checkSelectedItems);
                    let items = Array.from(set);
                    this.searchItems = [...items];
                }
            },
            allItems: {
                deep: true,
                handler(val) {
                      this.selectedItems = []
                      this.searchItems = []
                      this.hotelsKeys = []
                      this.selectedItem = {}
                      this.focusInputValue = ""
                      this.inputValue = ""
                      if (val.length) {
                        this.setValue();
                    }
                }
            },
            value(val, oldVal) {
                if (
                    val?.hotelKey === oldVal?.hotelKey &&
                    val?.categoryKey === oldVal?.categoryKey
                ) return;
                this.setValue()
            },
            focus(val) {
                if (val) {
                    window.addEventListener('keydown', this.keyDown);

                    this.$emit("focus", true)
                } else {
                    window.removeEventListener('keydown', this.keyDown);

                    this.$emit("blur", true)
                }
            },
            selectedItem: {
                deep: true,
                handler(val) {
                    if (!val) return
                    this.setText();

                    if (!val.hotelKey || this.hotelsKeys.some(x => x === val.hotelKey)) return
                    this.hotelsKeys.push(val.hotelKey)
                }
            },
            selectedItemsOnReboot: {
                deep: true,
                handler(val) {
                  if (val.length) {
                    // для сохранения выбранных отелей после перезагрузки странцы
                    this.selectedItems = val.map(item => {
                      item.text = item.hotelName
                      return item
                    }); 
                    this.hotelsKeys = val.map(item => item.hotelKey)
                    this.setValue()
                    const newComboItem = this.allItems.find(x => x.hotelKey === this.hotelsKeys.at(-1))
                    this.$emit('setComboItem', newComboItem)
                  }
                }
            }
        }
    }
</script>

<style scoped>
    .auto-complete {
        position: relative;
    }

    .auto-complete input {
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 40px 8px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
    }

    .auto-complete input::placeholder {
        color: var(--lighten-5-color);
    }

    .bg-effect {
        z-index: 100;
    }

    .input-list {
        overflow: auto;
        max-height: 60vh;
        min-width: calc(100% + 20px);
        max-width: 300px;
        position: absolute;
        top: -12px;
        left: -12px;
        z-index: 100;
        background-color: var(--white-color);
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border-radius: 4px;
    }

    .input-list .focus-input-wrap {
        margin: 12px;
        border: 2px solid var(--primary-color);
        border-radius: 3px;
        padding: 6px 6px 0 6px;
        display: flex;
        flex-wrap: wrap;
    }

    .input-list .focus-input-wrap .selected-items {
        background: var(--primary-color);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 6px;
        min-height: 32px;
        margin: 0 4px 4px 0;
    }

    .input-list .focus-input-wrap .selected-items.green {
        background: var(--green-color);
    }

    .input-list .focus-input-wrap .selected-items span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--white-color);
    }

    .input-list .focus-input-wrap .selected-items .close-icon {
        opacity: .7;
        margin-left: 3px;
        cursor: pointer;
    }

    .input-list .focus-input-wrap .selected-items .close-icon:hover {
        opacity: 1;
    }

    .input-list .focus-input-wrap input {
        background-color: transparent;
        padding: 3px 2px;
        margin-bottom: 4px;
    }

    .input-list .list-item {
        padding: 10px 12px;
        transition: all .2s;
        cursor: pointer;
    }
    .input-list .list-item.hover,
    .input-list .list-item:hover {
        background-color: var(--lighten-1-color);
    }

    .input-list .list-item .list-item-text {
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1-color);
        margin: 0;
        padding: 10px 12px 10px 24px;
        transition: all .2s;
        cursor: pointer;
    }

    .input-list .shadow-inset {
        width: 100%;
        height: 2px;
        box-shadow: 0 3px 5px rgba(100, 100, 100, .1);
    }
</style>